export const UCGEE = ['U', 'C', 'G', 'EE']
